import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    getWorkLoadsCalendar(filter) {
      const req = getState().find((req) => match(filter, req.filter));

      return req ? req.workLoads : [];
    },
    isRetrieveWorkLoadsRequestFailure(filter) {
      const req = getState().find((req) => match(filter, req.filter));

      return req ? req.request.isFailure : false;
    },
    isRetrieveWorkLoadsRequestPending(filter) {
      const req = getState().find((req) => match(filter, req.filter));

      return req ? req.request.isPending : false;
    },
    isRetrieveWorkLoadsRequestSuccess(filter) {
      const req = getState().find((req) => match(filter, req.filter));

      return req ? req.request.isSuccessful : false;
    },
    isWorkLoadsCalendarDirty(filter) {
      const req = getState().find((req) => match(filter, req.filter));

      return req ? req.isDirty : false;
    },
  };
}

export { createSelector };
